import { CartItemInterface, Maybe, Money } from '@pylot-data/pylotschema'

export const getGrandTotal = (
    items: Maybe<CartItemInterface>[],
    grandTotal?: Maybe<Money>
): Maybe<Money> | undefined => {
    const initialGrandTotal = {
        ...grandTotal,
        value: 0
    }

    return items?.reduce((prev, current) => {
        return {
            ...prev,
            value: prev.value + (current?.prices?.row_total.value || 0)
        }
    }, initialGrandTotal)
}
